export const ACTION_NAME_DELIMITER = '_';
export const ASYNC_ACTION_SUFFIXES = {
  FULFILLED: 'FULFILLED',
  REJECTED: 'REJECTED',
  CANCELLED: 'CANCELLED',
  CLEANUP: 'CLEANUP',
};
export const ASYNC_ACTION_TYPES = {
  BASIC: 'basic',
  POLLING: 'polling',
};
export const ASYNC_ACTION_PHASES = {
  TRIGGER: 'TRIGGER',
  FULFILL: 'FULFILL',
  REJECT: 'REJECT',
  CANCEL: 'CANCEL',
  CLEANUP: 'CLEANUP',
};
